import { HttpPromise, WixMpResponse } from '../../types/http-responses';

import { defaultServices, serviceNames } from '../../constants/project';
import { transport } from '../transport';

import { BASE_PATH, MEMBERS_PATH, PROJECT_PATH } from './config';
import _ from 'lodash';
import { Project } from '../../types/entities';

function createProject({ organizationId, project }) {
  const normalizedProject = {
    name: project.name,
    services: [],
  };

  if (project.videoPackagerServiceEnabled) {
    // name, instanceType, minimumInstanceNumber, maximumInstanceNumber
    const videoService = defaultServices[serviceNames.videoPackager];

    if (videoService) {
      normalizedProject.services.push();
    }
  }

  if (project.imageServiceEnabled) {
    const imageService = defaultServices[serviceNames.image];

    if (imageService) {
      normalizedProject.services.push();
    }
  }

  return transport.post<WixMpResponse<Project>>(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}`,
    normalizedProject,
  );
}

function getProjects({ organizationId }) {
  return transport.get<WixMpResponse<Project[]>>(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}`,
  );
}

function inviteProjectMember({ organizationId, projectId, member }) {
  const email = member.email;
  const securityGroups = _.uniq(member.securityGroups);

  return transport.post(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${MEMBERS_PATH}`,
    {
      email,
      securityGroups,
    },
  );
}

function removeProjectMember({ organizationId, projectId, memberId }) {
  return transport.delete(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${MEMBERS_PATH}/${memberId}`,
  );
}

function deleteProject({
  organizationId,
  projectId,
}: {
  organizationId: string;
  projectId: string;
}): HttpPromise {
  return transport.delete(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}`,
  );
}

export const projectService = {
  getProjects,
  removeProjectMember,
  inviteProjectMember,
  createProject,
  deleteProject,
};
